import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SprekerService } from '../spreker.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent {

  exploreClass = '';

  constructor(public router: Router) { }

  exploreClick() {
    // make the planet bigger
    this.exploreClass = 'exploreClicked';
    // wait until the animation is done, then navigate to the explore page
    this.sleep(2000).then(() => { this.router.navigate(['/explore']); });
  }


  // solution quoted from here: https://www.sitepoint.com/delay-sleep-pause-wait/
  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  // end of quote
}
